import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {SubscriptionsResponse} from '../models/subscription/subscriptions.response';
import {Subscription} from '../models/subscription/subscription.model';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(private http: HttpClient) {
  }

  private SUBSCRIPTION_URL: string = environment.BASE_URL + 'subscription';

  /**
   * GETS
   */
  public getSubscriptions(): Observable<SubscriptionsResponse> {
    return this.http.get<SubscriptionsResponse>(`${this.SUBSCRIPTION_URL}`).pipe(map(subscriptions => ({
      subscriptions: subscriptions.subscriptions.map(subscription => {
        subscription.startDate = new Date(subscription.startDate);
        return subscription;
      })
    })));
  }


  public getSubscription(id: string): Observable<Subscription> {
    return this.http.get<Subscription>(`${this.SUBSCRIPTION_URL}/${id}`).pipe(
      map(subscription => {
        subscription.startDate = new Date(subscription.startDate);
        return subscription;
      })
    );
  }

  /**
   * CREATES
   */
  public createSubscription(subscription: Subscription): Observable<Subscription> {
    return this.http.post<Subscription>(`${this.SUBSCRIPTION_URL}`, subscription).pipe(
      map(sub => {
        sub.startDate = new Date(sub.startDate);
        return sub;
      })
    );
  }


  /**
   * UPDATES
   */
  public updateSubscription(subscription: Subscription): Observable<Subscription> {
    return this.http.patch<Subscription>(`${this.SUBSCRIPTION_URL}/${subscription.id}`, subscription).pipe(
      map(sub => {
        sub.startDate = new Date(sub.startDate);
        return sub;
      })
    );
  }


  /**
   * DELETE
   */
  public deleteSubscription(id: string): Observable<Subscription> {
    return this.http.delete<Subscription>(`${this.SUBSCRIPTION_URL}/${id}`).pipe();
  }

}
